import { createSelector } from "reselect";

const LOAD_UNREAD_COUNT = "LOAD_UNREAD_COUNT";
const INCREMENT_UNREAD = "INCREMENT_UNREAD";
const DECREMENT_UNREAD = "DECREMENT_UNREAD";
const RESET_UNREAD = "RESET_UNREAD";

const initialState = {
  unreadCount: 0,
};

export const setUnreadCount = (count) => ({
  type: LOAD_UNREAD_COUNT,
  payload: count,
});

export const incrementUnreadCount = () => ({ type: INCREMENT_UNREAD });
export const decrementUnreadCount = () => ({ type: DECREMENT_UNREAD });
export const resetUnreadCount = () => ({ type: RESET_UNREAD });

const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_UNREAD_COUNT:
      return { ...state, unreadCount: action.payload };
    case INCREMENT_UNREAD:
      return { ...state, unreadCount: state.unreadCount + 1 };
    case DECREMENT_UNREAD:
      return { ...state, unreadCount: Math.max(0, state.unreadCount - 1) };
    case RESET_UNREAD:
      return { ...state, unreadCount: 0 };
    default:
      return state;
  }
};

const getNotificationsState = (state) => state.notifications;

export const getUnreadCount = createSelector(
  getNotificationsState,
  (s) => s?.unreadCount || 0,
);

export default notificationsReducer;
